import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function TransparentInspection() {
  const listItems = ['Photos and video from your vehicle', 'Technician notes explaining what was found', 'Repair recommendations prioritized by urgency', 'A clear estimate before anything is approved'];
  return <section className="py-20 px-4 bg-brand-light pt-[77px] pb-[77px]" data-id="element-199">
      <div className="max-w-4xl mx-auto" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-201">
          <img src="https://cdn.magicpatterns.com/uploads/v5w4cpb7uAJvjUTD8b3jRB/Lancer_Circle3x.png" alt="Lancer Service - Auto Repair & Maintenance" className="w-40 h-40 md:w-52 md:h-52 mx-auto mb-8 drop-shadow-lg" data-id="element-202" />
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-203">
            Transparency on every visit
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-dark mb-6 pl-[43px] pr-[43px]" data-id="element-204">
            You see exactly what we see.
          </h2>
          <div className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed space-y-4" data-id="element-205">
            <p data-id="element-206">
              Every visit includes a full Digital Vehicle Inspection — photos
              and video of your actual car, notes in plain English, and a clear
              breakdown of what needs attention now versus what can wait.
            </p>
            <p className="font-medium text-brand-dark pl-[24px] pr-[24px]" data-id="element-207">
              For Toyota owners planning to keep their vehicle for the long
              haul, this is how you stay ahead of problems instead of reacting
              to them.
            </p>
          </div>
        </motion.div>

        <div className="bg-white rounded-2xl p-8 md:p-12 border border-gray-200 shadow-sm mb-10" data-id="element-208">
          <p className="font-bold text-brand-dark text-lg mb-6" data-id="element-209">
            You'll receive:
          </p>
          <ul className="space-y-6" data-id="element-210">
            {listItems.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4" data-id="element-211">
                <CheckCircleIcon className="w-6 h-6 text-brand-accent flex-shrink-0 mt-0.5" data-id="element-212" />
                <span className="text-lg text-gray-800 font-medium" data-id="element-213">
                  {item}
                </span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center space-y-2 pl-[16px] pr-[16px]" data-id="element-214">
          <p className="text-brand-dark font-bold text-xl max-w-2xl mx-auto pl-[58px] pr-[58px]" data-id="element-215">
            Nothing gets touched without your go-ahead.
          </p>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto pl-[46px] pr-[46px]" data-id="element-216">
            And if something isn't urgent, we'll say so.
          </p>
        </motion.div>
      </div>
    </section>;
}